export class RecorderDependenciesExistsError extends Error {
  constructor(err: Error) {
    super(err.message)
    Object.setPrototypeOf(this, RecorderDependenciesExistsError.prototype)
  }
}
